import { render, staticRenderFns } from "./ActualizarClientes.vue?vue&type=template&id=040cd842"
import script from "./ActualizarClientes.vue?vue&type=script&lang=js"
export * from "./ActualizarClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports